import React, {useEffect, useState} from "react";
import BaseScreen from "../base/BaseScreen";
import {
    BasicGrid,
    primaryBlack,
    inter,
    purpleLighter,
    SmallHeaderTitle,
    white,
} from "../../Theme";
import styled from "styled-components";
import {device} from "../../constants/breakpoints";
import Api from "../../util/Api";
import {useHistory} from "react-router-dom";
import {Loader} from "../../components/Loader";
import {showNativeNavigation} from "../../AppInterface";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { PupilSchoolYearSelector } from "../../components/PupilSchoolYearSelector/PupilSchoolYearSelector";

function ExecutiveFunctionOverviewScreen(props) {
    const [executiveFunctions, setExecutiveFunctions] = useState([]);
    const history = useHistory();

    useEffect(() => {
        showNativeNavigation();
        Api.get(`executiveFunctions`, (response) => {
            setExecutiveFunctions(response.data)
        });
    }, []);

    const breakpoint = "820px";

    const content = (
        <EFOverViewRoot>

            {executiveFunctions.length === 0 &&
                <Loader/>
            }

            <PageHeader breakpoint={breakpoint}>
                <PageHeader.Center breakpoint={breakpoint}>
                    <SmallHeaderTitle>Executieve Functies</SmallHeaderTitle>
                </PageHeader.Center>
                <PageHeader.End breakpoint={breakpoint}>
                    <PupilSchoolYearSelector />
                </PageHeader.End>
            </PageHeader>

            <EFGridWrapper>
                <StyledBasicGrid>
                    {executiveFunctions.map((ef, index) => {
                        return (
                            <EFCard key={ef.id} color={ef.color} onClick={() => navigateToExecutiveFunction(ef)}>
                                <EFIcon color={ef.hasDarkText ? primaryBlack : white}>{index + 1}</EFIcon>
                                <EFTitle color={ef.hasDarkText ? primaryBlack : white}>{ef.title}</EFTitle>
                                <EFSubtitle color={ef.hasDarkText ? primaryBlack : white}>{ef.subtitle}</EFSubtitle>
                            </EFCard>
                        )
                    })}
                </StyledBasicGrid>
            </EFGridWrapper>
        </EFOverViewRoot>
    );

    return (
        <BaseScreen
            activeMenuItem={"Executieve Functies"}
            content={content}
        />
    )

    function navigateToExecutiveFunction(executiveFunction) {
        history.push(`/executieve-functies/ ${executiveFunction.id} ?periodId=${executiveFunction.periodFilterOptions[0].value}`, {executiveFunction: executiveFunction})
    }
}

const EFOverViewRoot = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

const EFGridWrapper = styled.div`
    margin: 0 auto;
    max-width: 1050px;
    padding: 40px;

    @media screen and ${device.laptop} {
        padding: 17px;
    }   
`;

const StyledBasicGrid = styled(BasicGrid)`
    @media screen and ${device.tabletS} {
        grid-template-columns: 1fr;
    }
`;

const EFSubtitle = styled.div`
    color: ${props => props.color};
    font-family: ${inter};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    margin-top: 12px;
    text-align: center;
`;

const EFIcon = styled.div`
    color: ${props => props.color};
    background-color: rgba(0, 0, 0, 0.15);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    flex-shrink: 0;
`;

const EFTitle = styled.div`
    color: ${props => props.color};
    font-family: ${inter};
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    margin-top: 10px;
    text-align: center;
`;

const EFCard = styled.a`
    background: ${props => props.color ? props.color : purpleLighter};
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 40px;
    transition: all 0.15s ease;

    &:hover {
        transform: scale(1.05);
    }
`;

export default ExecutiveFunctionOverviewScreen;
